import { render, staticRenderFns } from "./DiscountLabel.vue?vue&type=template&id=38c78868&scoped=true&"
import script from "./DiscountLabel.vue?vue&type=script&lang=js&"
export * from "./DiscountLabel.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLabel.vue?vue&type=style&index=0&id=38c78868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c78868",
  null
  
)

export default component.exports